import { useLang } from "@/context/LanguageContext";

const CONTENT = {
  ar: {
    title: "الشروط والأحكام",
    updated: "آخر تحديث: يوليو 2026",
    intro:
      "مرحباً بك في ARTLENSS. باستخدامك لموقعنا artlenss.com أو تعاقدك معنا لتقديم خدمات إنتاج سينمائي، فإنك تُوافق على الشروط والأحكام التالية. هذه الوثيقة تحكم علاقتنا بك سواء كنت زائراً أو عميلاً أو شريكاً فنّياً.",
    sections: [
      {
        h: "١. تعريفات",
        p: "‘الاستوديو’ أو ‘نحن’: ARTLENSS · استوديو الإنتاج السينمائي المسجّل في جدة، المملكة العربية السعودية. ‘الخدمة’: أيّ عمل إنتاجي سمعي/بصري نقدّمه (أفلام، إعلانات، وثائقيات، تصوير منتجات، موشن جرافيك، تسجيل صوتي…). ‘العميل’: أيّ فرد أو جهة تتعاقد معنا. ‘المحتوى النهائي’: الملفات المسلَّمة بعد اعتماد المسوّدة.",
      },
      {
        h: "٢. طبيعة الخدمة",
        p: "ARTLENSS استوديو إنتاج مستقل يقدّم خدمات ما قبل الإنتاج (تطوير الفكرة، السيناريو، الستوري بورد)، الإنتاج (تصوير، إخراج، صوت)، وما بعد الإنتاج (مونتاج، تصحيح ألوان، موشن جرافيك، مكس صوت). كل مشروع يبدأ بوثيقة موجز إبداعي (Creative Brief) تُوقَّع من الطرفين.",
      },
      {
        h: "٣. عرض الأسعار والدفع",
        p: "نُصدر عرض سعر كتابي يشمل نطاق العمل، الجدول الزمني، وعدد التعديلات. لا يبدأ التنفيذ إلا بعد دفع دفعة مقدّمة تتراوح بين ٣٠٪ و ٥٠٪ من قيمة العقد. الدفعات اللاحقة تُستحقّ عند مراحل التسليم المحدّدة، ودفعة نهائية عند تسليم المحتوى النهائي. يحتفظ الاستوديو بحق تعليق العمل عند تأخّر أيّ دفعة عن موعدها بأكثر من ١٤ يوماً.",
      },
      {
        h: "٤. التعديلات والمراجعات",
        p: "يشمل كل عقد جولتين إلى ثلاث جولات مراجعة قبل الاعتماد النهائي (يُحدَّد بالتفصيل في عرض السعر). أيّ جولة إضافية أو تغيير جوهري في نطاق العمل بعد الاعتماد يُعتبر عملاً إضافياً (Change Order) وتُطبَّق عليه أسعار مستقلّة.",
      },
      {
        h: "٥. الملكية الفكرية",
        p: "قبل السداد الكامل: تظلّ حقوق المحتوى النهائي مملوكة لـ ARTLENSS. بعد السداد الكامل: تنتقل حقوق الاستخدام التجاري للعميل ضمن النطاق المتفق عليه (الوسائط، الأسواق، والمدة). تحتفظ ARTLENSS دائماً بـ: (أ) حق عرض المشروع في محفظتها الفنّية، (ب) الملفّات الخام (RAW) والمشاريع القابلة للتحرير — إلا إذا اتُّفق كتابياً على غير ذلك.",
      },
      {
        h: "٦. سرّية العميل",
        p: "نلتزم بسرّية تامّة تجاه أيّ سيناريو أو خطة تسويقية أو وثيقة إبداعية يشاركها العميل معنا. عند الطلب، نوقّع اتفاقيات عدم إفشاء (NDA) قبل بدء المشروع دون أيّ رسوم إضافية.",
      },
      {
        h: "٧. الإلغاء وردّ المبالغ",
        p: "إذا رغب العميل بإلغاء المشروع قبل بدء التصوير: تُردّ نسبة ٧٠٪ من الدفعة المقدّمة. إذا أُلغي بعد بدء التصوير أو ما بعد الإنتاج: لا تُردّ الدفعات مقابل الوقت والموارد المستهلَكة، ويُسلَّم للعميل ما تمّ إنتاجه حتى تاريخ الإلغاء.",
      },
      {
        h: "٨. المسؤولية",
        p: "نلتزم بأفضل معايير الجودة الفنّية والتنفيذية، لكنّ ARTLENSS غير مسؤول عن: تأخيرات ناتجة عن أطراف ثالثة (مواقع التصوير، الطقس، تأخّر تصاريح حكومية)، أو عن استخدام العميل للمحتوى بطرق مخالفة للأنظمة السعودية أو الدولية. الحدّ الأقصى لأيّ مسؤولية مالية لا يتجاوز قيمة العقد المدفوعة فعلياً.",
      },
      {
        h: "٩. حقوق الطرف الثالث",
        p: "يتحمّل العميل مسؤولية الحصول على تراخيص أيّ موسيقى أو صور أو شعارات يقدّمها لنا لاستخدامها في المشروع. عند اعتمادنا على مكتباتنا الخاصة (الموسيقى، المؤثرات، الخطوط)، نضمن أنها مرخّصة قانونياً للاستخدام التجاري.",
      },
      {
        h: "١٠. القوة القاهرة",
        p: "لا يُعتبر أيّ طرف مُخِلاً بالعقد في حال حدوث ظروف قاهرة تمنع التنفيذ (الأزمات الصحّية العامة، الكوارث الطبيعية، القيود الحكومية المفاجئة). في هذه الحالة، يُعاد جدولة المشروع بالتوافق دون أيّ غرامة.",
      },
      {
        h: "١١. القانون الحاكم",
        p: "تخضع هذه الشروط لأنظمة المملكة العربية السعودية، وتُحلّ أيّ نزاعات ودّياً أولاً، ثمّ عبر الجهات القضائية المختصّة في مدينة جدة إذا لزم.",
      },
      {
        h: "١٢. التواصل",
        p: "لأيّ استفسار متعلّق بهذه الشروط، تواصل معنا على: info@artlenss.com · +٩٦٦ ٥٥ ٤١٤ ٢٠٠٧ · ARTLENSS Studio · جدة، المملكة العربية السعودية.",
      },
    ],
  },
  en: {
    title: "Terms of Service",
    updated: "Last updated: July 2026",
    intro:
      "Welcome to ARTLENSS. By using artlenss.com or contracting us for cinematic production services, you agree to the following Terms of Service. This document governs our relationship with you, whether you are a visitor, a client, or a creative partner.",
    sections: [
      {
        h: "1. Definitions",
        p: "'The Studio' or 'we': ARTLENSS — a cinematic production studio registered in Jeddah, Saudi Arabia. 'Service': any audiovisual production work we deliver (films, commercials, documentaries, product photography, motion graphics, sound recording, etc.). 'Client': any individual or entity contracting with us. 'Final Deliverable': the files delivered after final approval.",
      },
      {
        h: "2. Nature of Service",
        p: "ARTLENSS is an independent production studio offering pre-production (concept development, scripting, storyboarding), production (directing, cinematography, sound), and post-production (editing, color grading, motion graphics, sound mixing). Every project begins with a signed Creative Brief.",
      },
      {
        h: "3. Quotations & Payment",
        p: "We issue a written quotation covering scope of work, timeline, and number of revisions. Work begins only after a 30–50% deposit is paid. Subsequent payments are due at defined milestones, with a final payment upon delivery of the Final Deliverable. The Studio reserves the right to pause work if any payment is delayed beyond 14 days.",
      },
      {
        h: "4. Revisions & Reviews",
        p: "Every contract includes two to three rounds of revisions before final approval (specified in the quotation). Any additional round or material change to the scope after approval is treated as a Change Order and priced separately.",
      },
      {
        h: "5. Intellectual Property",
        p: "Before full payment: rights to the Final Deliverable remain with ARTLENSS. After full payment: commercial usage rights transfer to the Client within the agreed scope (media, markets, duration). ARTLENSS always retains: (a) the right to feature the project in its portfolio, (b) ownership of RAW files and editable project files — unless agreed otherwise in writing.",
      },
      {
        h: "6. Client Confidentiality",
        p: "We maintain full confidentiality over any script, marketing plan, or creative document shared with us. On request, we sign an NDA before project kick-off at no additional charge.",
      },
      {
        h: "7. Cancellation & Refunds",
        p: "If cancelled before shooting begins: 70% of the deposit is refunded. If cancelled after shooting or during post-production: deposits are non-refundable, and the Client receives all work completed to the cancellation date.",
      },
      {
        h: "8. Liability",
        p: "We commit to the highest technical and creative standards, but ARTLENSS is not liable for: delays caused by third parties (locations, weather, government permits), or for the Client's use of content in violation of Saudi or international regulations. Maximum liability is limited to the contract value actually paid.",
      },
      {
        h: "9. Third-Party Rights",
        p: "The Client is responsible for licensing any music, images, or logos it provides for use in the project. Where we use our own libraries (music, effects, fonts), we guarantee they are legally licensed for commercial use.",
      },
      {
        h: "10. Force Majeure",
        p: "Neither party is considered in breach if performance is prevented by force majeure (public health crises, natural disasters, sudden government restrictions). In such cases, the project is rescheduled by mutual agreement with no penalty.",
      },
      {
        h: "11. Governing Law",
        p: "These Terms are governed by the laws of the Kingdom of Saudi Arabia. Disputes are resolved amicably first, and thereafter through the competent courts in Jeddah if needed.",
      },
      {
        h: "12. Contact",
        p: "For any inquiry regarding these Terms, reach us at: info@artlenss.com · +966 55 414 2007 · ARTLENSS Studio · Jeddah, Saudi Arabia.",
      },
    ],
  },
};

const Terms = () => {
  const { lang } = useLang();
  const c = CONTENT[lang];
  return (
    <div data-testid="terms-page">
      <section className="pt-32 pb-10 md:pt-40 md:pb-14">
        <div className="container-x max-w-4xl">
          <div className="overline mb-6">ARTLENSS · Legal</div>
          <h1 className="display-h1">{c.title}</h1>
          <p className="mt-6 text-white/50 text-sm uppercase tracking-[0.24em]">{c.updated}</p>
          <p className="mt-10 text-white/80 text-lg md:text-xl leading-relaxed">{c.intro}</p>
        </div>
      </section>

      <section className="pb-24 md:pb-32">
        <div className="container-x max-w-4xl space-y-10">
          {c.sections.map((sec, i) => (
            <article key={i} className="border-t border-white/10 pt-8">
              <h2 className="font-display text-2xl md:text-3xl text-[#E6A95B] mb-4">{sec.h}</h2>
              <p className="text-white/75 text-lg leading-[1.9]">{sec.p}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Terms;
